// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.alerted {
  display: block;
  border-bottom: none;
  font-size: 30px;
  color: #990000;
}
.dashboard-widget-screening {
  transition: transform 0.5s;
  transform-style: preserve-3d;
  box-shadow: 3px 2px 10px #89889c;
  width: calc(90vw - 40px - 220px);
  height: 100%;
  margin: 20px;
}
.screening-widget {
  padding: 10px;
  perspective: 6000px;
  height: 50vh;
}
.widget-face {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background: white;
}
.widget-face.front {
  display: flex;
  align-content: space-between;
  flex-flow: column nowrap;
}
.widget-face.back {
  background: white;
  transform: rotateX(180deg);
  overflow-y: hidden;
}
.is-flipped {
  transform: rotatex(180deg);
}
.widget-title {
  border-bottom: 2px solid #dedefd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
}
h1 {
  font-size: 20px;
  font-weight: 400;
  color: #43425d;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background: white;
  border: 0 !important;
}
h1 i {
  color: #a29ffa;
  padding-right: 10px;
  font-size: 24px;
}
i.fa-cog {
  display: block;
  justify-content: right;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
  color: #a29ffa;
}
h1 input[type="button"] {
  margin-left: 20px;
}
.footer {
  background: #0f1a35;
  width: 100%;
  padding: 5px;
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 0;
}
.footer input[type="button"] {
  box-shadow: 1px 2px 3px black;
}
/* TABLE */
.grid {
  grid-template-columns: repeat(6, auto);
  height: auto;
  overflow-y: scroll;
}
.grid i {
  padding-right: 10px;
  cursor: pointer;
}
.grid i.fa-thumbs-up,
.grid i.fa-search {
  padding-right: 5px;
}
.loader {
  padding-top: 5%;
  border-bottom: none;
  text-align: center;
}
.controls {
  position: relative;
  background: white;
  top: 200px;
  left: calc(50vw - 300px);
  border-radius: 5px;
  width: 300px;
  height: 150px;
  box-shadow: 1px 2px 3px black;
  text-align: center;
}
.controls h3 {
  font-size: 18px;
  color: white;
  background: #ce6161;
  border-bottom: 1px solid black;
  padding: 10px;
  border-radius: 5px 5px 0 0;
}
.controls p {
  padding: 10px;
  padding-top: 0;
  margin: 0;
}
.controls input[value="Continue"] {
  background: #54a54e;
  color: white;
}
.controls input[value="Cancel"] {
  background: #8e9bb5;
  color: white;
}
#propertyDecisions {
  height: 2.2em;
}
.notice {
  font-size: 12px;
}
.overlay {
  position: fixed;
  top: -30px;
  left: -30px;
  height: calc(100vh - 70px);
  width: calc(100vw - 220px);
  background: rgba(15, 26, 53, 0.3);
  z-index: 100;
}
/* WIDGET SETTINGS */
ul {
  padding-top: 10px;
}
ul:before {
  font-size: 12px;
  content: "Select which columns you would like to display:";
}
li {
  font-size: 13px;
  line-height: 1.8;
  padding: 1px 0;
}
li:first-child {
  padding: 10px 0 10px 45px;
}
li span {
  display: inline-block;
  width: 20px;
  text-align: right;
  margin-right: 25px;
}
li i {
  font-size: 14px;
  color: black;
  padding-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/widgets/alerts-widget/alerts-widget.component.less"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AADJ;AAIA;EACI,0BAAA;EACA,4BAAA;EACA,gCAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;AAFJ;AAIA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAIA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;AAFJ;AAIA;EACI,aAAA;EACA,4BAAA;EACA,wBAAA;AAFJ;AAIA;EACI,iBAAA;EACA,0BAAA;EACA,kBAAA;AAFJ;AAIA;EACI,0BAAA;AAFJ;AAIA;EACC,gCAAA;EACA,aAAA;EACG,mBAAA;EACA,8BAAA;EACA,kBAAA;AAFJ;AAIA;EACC,eAAA;EACG,gBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAFJ;AAIA;EACC,cAAA;EACA,mBAAA;EACG,eAAA;AAFJ;AAIA;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AAFJ;AAIA;EACI,iBAAA;AAFJ;AAIA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAFJ;AAIA;EACI,6BAAA;AAFJ;AACA,UAAU;AAKV;EACI,sCAAA;EACA,YAAA;EACA,kBAAA;AAHJ;AAKA;EACI,mBAAA;EACA,eAAA;AAHJ;AAKA;;EACI,kBAAA;AAFJ;AAIA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAKA;EACI,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AAHJ;AAKA;EACI,eAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;AAHJ;AAKA;EACI,aAAA;EACA,cAAA;EACA,SAAA;AAHJ;AAKA;EACI,mBAAA;EACA,YAAA;AAHJ;AAKA;EACI,mBAAA;EACA,YAAA;AAHJ;AAKA;EACI,aAAA;AAHJ;AAKA;EACI,eAAA;AAHJ;AAKA;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,iCAAA;EACA,YAAA;AAHJ;AACA,oBAAoB;AAOpB;EACC,iBAAA;AALD;AAOA;EACC,eAAA;EACA,0DAAA;AALD;AAOA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AALJ;AAOA;EACI,yBAAA;AALJ;AAOA;EACC,qBAAA;EACA,WAAA;EACG,iBAAA;EACA,kBAAA;AALJ;AAOA;EACI,eAAA;EACA,YAAA;EACA,mBAAA;AALJ","sourcesContent":["@import (reference) '../../../styles.less';\n\ndiv.alerted{\n    display: block;\n    border-bottom: none;\n    font-size: 30px;\n    color :#990000;\n}\n\n.dashboard-widget-screening {\n    transition: transform 0.5s;\n    transform-style: preserve-3d;\n    box-shadow: 3px 2px 10px @dropshadow;\n    width: ~\"calc(90vw - 40px - @{sidebar-width})\";\n    height: 100%;\n    margin: 20px;\n}\n.screening-widget {\n    padding: 10px;\n    perspective: 6000px;\n    height: 50vh;\n}\n.widget-face {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    backface-visibility: hidden;\n    background: white;\n}\n.widget-face.front {\n    display: flex;\n    align-content: space-between;\n    flex-flow: column nowrap;\n}\n.widget-face.back {\n    background: white;\n    transform: rotateX(180deg);\n    overflow-y: hidden;\n}\n.is-flipped {\n    transform: rotatex(180deg);\n}\n.widget-title {\n\tborder-bottom: 2px solid @plpurple;\n\tdisplay: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n}\nh1 {\n\tfont-size: 20px;\n    font-weight: 400;\n    color: @dkpurple;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    background: white;\n    border: 0 !important;\n}\nh1 i {\n\tcolor: @brpurple;\n\tpadding-right: 10px;\n    font-size: 24px;\n}\ni.fa-cog {\n    display: block;\n    justify-content: right;\n    cursor: pointer;\n    padding: 0;\n    font-size: 18px;\n    color: @brpurple;\n}\nh1 input[type=\"button\"] {\n    margin-left: 20px;\n}\n.footer {\n    background: @dkblue;\n    width: 100%;\n    padding: 5px;\n    text-align: center;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n.footer input[type=\"button\"] {\n    box-shadow: @button-drop @darkshadow;\n}\n\n/* TABLE */\n.grid {\n    grid-template-columns: repeat(6, auto);\n    height: auto;\n    overflow-y: scroll;\n}\n.grid i {\n    padding-right: 10px;\n    cursor: pointer;\n}\n.grid i.fa-thumbs-up, .grid i.fa-search {\n    padding-right: 5px;\n}\n.loader {\n    padding-top: 5%;\n    border-bottom: none;\n    text-align: center;\n}\n\n.controls {\n    position: relative;\n    background: white;\n    top: 200px;\n    left: calc(50vw - 300px);\n    border-radius: 5px;\n    width: 300px;\n    height: 150px;\n    box-shadow: 1px 2px 3px @darkshadow;\n    text-align: center;\n}\n.controls h3 {\n    font-size: 18px;\n    color: white;\n    background: @red;\n    border-bottom: 1px solid black;\n    padding: 10px;\n    border-radius: 5px 5px 0 0;\n}\n.controls p {\n    padding: 10px;\n    padding-top: 0;\n    margin: 0;\n}\n.controls input[value=\"Continue\"] {\n    background: @green;\n    color: white;\n}\n.controls input[value=\"Cancel\"] {\n    background: @grey;\n    color: white;\n}\n#propertyDecisions {\n    height: 2.2em;\n}\n.notice {\n    font-size: 12px;\n}\n.overlay {\n    position: fixed;\n    top: -30px;\n    left: -30px;\n    height: calc(100vh - @header-height);\n    width: calc(100vw - @sidebar-width);\n    background: @overlay;\n    z-index: 100;\n}\n\n/* WIDGET SETTINGS */\n\nul {\n\tpadding-top: 10px;\n}\nul:before {\n\tfont-size: 12px;\n\tcontent: \"Select which columns you would like to display:\";\n}\nli {\n    font-size: 13px;\n    line-height: 1.8;\n    padding: 1px 0;\n}\nli:first-child {\n    padding: 10px 0 10px 45px;\n}\nli span {\n\tdisplay: inline-block;\n\twidth: 20px;\n    text-align: right;\n    margin-right: 25px;\n}\nli i {\n    font-size: 14px;\n    color: black;\n    padding-right: 10px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
